// extracted by mini-css-extract-plugin
export var closeButton = "_19-1";
export var container = "_19-0";
export var fullModalImage = "_19-2";